module.exports = __webpack_public_path__ + "img/relatedWords_icon.e48fad8.png";